export const APP_STORE_URL =
  "https://apps.apple.com/in/app/splurge-finance/id6758099078";

export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.techsimba.splurge";

export const INSTAGRAM_URL = "https://www.instagram.com/splurgefinance";

export const GOOGLE_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSdauoNpuzbE8tghFUNR1uZsjR8Aj8FODYytWivkf9tDCS-Tyg/viewform";

export const NAV_LINKS = [
  { id: "why", label: "Why Splurge" },
  { id: "features", label: "Features" },
  { id: "how", label: "How It Works" },
  { id: "about", label: "About" },
];
